export { default as StoreDetailsPage } from "./View";
